export const messenger = {
    title: ['Сообщения', 'Messages'],
    searchPlaceholder: ['Поиск чатов', 'Search chats'],
    inputPlaceholder: ['Введите сообщение', 'Type a message'],
    selectChat: ['Выберите чат, чтобы начать переписку', 'Select a chat to start messaging'],
    noChats: ['Нет доступных чатов', 'No chats available'],
    noMessages: ['Нет сообщений', 'No messages'],
    untitledChat: ['Без названия', 'Untitled'],
    statusQueued: ['в очереди', 'queued'],
    statusSending: ['отправляется', 'sending'],
    statusDelivered: ['доставлено', 'delivered'],
    statusRead: ['прочитано', 'read'],
    statusFailed: ['не отправлено', 'not sent'],
    newChat: ['Новый чат', 'New chat'],
    newGroup: ['Группа', 'Group'],
    newPersonal: ['Личный', 'Personal'],
    groupNamePlaceholder: ['Название группы', 'Group name'],
    groupMembersStep: ['Добавить участников', 'Add members'],
    createGroup: ['Создать', 'Create'],
    nextStep: ['Далее', 'Next'],
    backStep: ['Назад', 'Back'],
    members: ['Участники', 'Members'],
    membersTitle: ['Участники', 'Members'],
    addMembers: ['Добавить участников', 'Add members'],
    add: ['Добавить', 'Add'],
    owner: ['Создатель', 'Owner'],
    membersSearch: ['Поиск сотрудника', 'Search employee'],
    recipientsTitle: ['Выберите адресата', 'Select a recipient'],
    recipientsSearch: ['Поиск адресата', 'Search recipient'],
    noRecipients: ['Нет доступных адресатов', 'No recipients available'],
    attach: ['Прикрепить файл', 'Attach a file'],
    recordVoice: ['Записать голосовое', 'Record voice message'],
    stopRecording: ['Остановить запись', 'Stop recording'],
    voiceMessage: ['Голосовое сообщение', 'Voice message'],
    playVoice: ['Воспроизвести', 'Play'],
    voicePermissionDenied: ['Нет доступа к микрофону', 'Microphone access denied'],
    voiceRecordFailed: ['Не удалось записать голосовое', 'Could not record voice message'],
    voiceUnsupported: ['Запись голоса не поддерживается на этом устройстве', 'Voice recording is not supported on this device'],
    attachmentTooLarge: ['Файл слишком большой (макс. 10 МБ)', 'File is too large (max 10 MB)'],
    attachmentUnsupported: ['Неподдерживаемый тип файла', 'Unsupported file type'],
    attachmentsHint: ['jpeg, png, pdf, doc, xls, голос — до 10 МБ', 'jpeg, png, pdf, doc, xls, voice — up to 10 MB'],
    attachmentLabel: ['Вложение', 'Attachment'],
    emptyMessage: ['(пустое сообщение)', '(empty message)'],
    cancel: ['Отмена', 'Cancel'],
    download: ['Скачать', 'Download'],
    close: ['Закрыть', 'Close'],
};
